import HundredBricksAPIError from '../../HundredBricksAPIError';
class VerifyPhoneError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('VerifyPhoneError', ...args);
    }
}
export default VerifyPhoneError;
